export default {
    one: {
      active: require("./../../../../assets/img/ic_1.png"),
      text:'(Less than 30 %)'
    },
    two: {
      active: require("./../../../../assets/img/ic_2.png"),
      text:'(b/w 30 % to 50%)'
    },
    three: {
      active: require("./../../../../assets/img/ic_3.png"),
      text:'(b/w 50 % to 70%)'
    },
    four: {
      active: require("./../../../../assets/img/ic_4.png"),
      text:'(b/w 70 % to 90 %)'
    },
    five: {
      active: require("./../../../../assets/img/ic_5.png"),
      text:'(Above 90%)'
    },
  };